<template>
  <div class="container-fluid">
  	<div class="row">
  		<div id="news-feed-content" class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 no-pad-both">
  			<ul id="news-feed-ul">
          <template v-for="(news,index) in newsData">
            <NewsList :newsData="news" :key="index"></NewsList>
          </template>
  			</ul>
  		</div>
  	</div>
  </div>
</template>

<script>
import NewsList from '@/components/NewsList.vue'
import axios from 'axios'

export default {
  data() {
    return {
      newsData: [],
    }
  },
  components: {
    NewsList
  },
  created() {
    var platform = 'web';
  	if(this.$DeviceCheck.isMobile) { platform = 'mobile' };
  	if(this.$DeviceCheck.isIOS) { platform = 'ios' };
  	if(this.$DeviceCheck.isAndroid) { platform = 'android' };

    axios.get('https://api.odenserundt.dk/v1/notify/'+platform)
    .then(response => {
      this.newsData = response.data;
      //console.log(this.newsData);
      this.sortNewsData();
    })
    .catch(function (error) {
      console.log(error);
    });
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Nyt');
  },
  mounted() {
    this.$el.addEventListener('click', this.checkLink);
    this.$HelperFunctions.setScreenReaderFocus();
  },
  methods: {
    sortNewsData() {
      this.newsData.sort(function(a, b) {
  			var aStart = a.start;
  			var bStart = b.start;
  			return ((aStart > bStart) ? -1 : ((aStart < bStart) ? 1 : 0));
  		});
    },
    checkLink(event) {
      event.preventDefault();
      var href = event.target.href;
      if(href != undefined) {
        if(href.indexOf('odenserundt.dk') != -1) {
          let split = href.split('odenserundt.dk');
    			this.$router.push(split[1]);
        }
        else {
          window.open(href, '_system', '');
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  #news-feed-content {
    height: auto;
    min-height: 300px;
    overflow-y: auto;
  }

  #news-feed-content {
    margin-top: 10px;
  }
</style>
